import { NgClass } from "@angular/common";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

type ColorData = {
    color: string;
    description: string;
};

type IconData = {
    color: string;
    description: string;
    icon: string;
};

@Component({
    selector: "rask-planera-color-explanation-popover",
    templateUrl: "./planera-color-explanation-popover.component.html",
    styleUrl: "./planera-color-explanation-popover.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        NgbPopover
    ]
})
export class PlaneraColorExplanationPopoverComponent {
    protected readonly colors: ColorData[] = [
        { color: "red",
            description: "Ej tillgänglig" },
        { color: "yellow",
            description: "Tillgänglig" },
        { color: "blue",
            description: "Produktion pågår" },
        { color: "gray",
            description: "Produktion avslutad" },
        { color: "green",
            description: "Slutrapporterad" },
        { color: "purple",
            description: "Arbetsorder avslutad" }
    ];
}
